import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastraAtendimentoPj } from './types';

export const INITIAL_STATE: CadastraAtendimentoPj = {
	status: 0,
	data: null,
	dadosAtendimento: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastraAtendimentoPj {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRA_ATENDIMENTO_PJ_REQUEST: {
				draft.dadosAtendimento = action.payload;
				break;
			}
			case Types.CADASTRA_ATENDIMENTO_PJ_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.CADASTRA_ATENDIMENTO_PJ_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CADASTRA_ATENDIMENTO_PJ_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
